import React from "react";
import { TrashFill } from "react-bootstrap-icons";
import "../../styles/file.scss";
import {extensionsAccepted,decode_utf8} from "../../utils/utilsFunc"
import { CGE } from "../CGE";

const FileUploader = ({deleteFile,idInput,labelInput,onFileSelectSuccess,setErroUploadFile,dataProps,mandatoryElement, maxFileSize, typeFile, hasError, msgError, msgErrorFileSize, multiFiles = true}) => {
    const [dataFile,setDataFile] = React.useState(null);
    const [titleFile,setTitleFile] = React.useState("");
    const [nameFile,setNameFile] = React.useState("");

    const handleFileInput = (e) => {
        const file = e.target.files;
        let setErro = false;
        let auxTitleFile = "";

        if(file.length > 0 && multiFiles) {
            setTitleFile("");
            setNameFile("");

            for(var i =0; i<file.length; i++)
            {
                var size = parseFloat(file[i].size / (1024 * 1024)).toFixed(2);

                if(size > maxFileSize) {
                    setErroUploadFile(msgErrorFileSize);
                    setErro = true;
                    if(!multiFiles){
                        setDataFile(null) 
                        onFileSelectSuccess(null);
                    }
                } else if (!extensionsAccepted(file[i].name,typeFile)) {
                    setErroUploadFile(decode_utf8(dataProps?.erro_extension_no_compatible)+"["+typeFile.replaceAll(';',' - ')+"]");
                    setErro = true;
                    if(!multiFiles){
                        setDataFile(null) ;
                        onFileSelectSuccess(null);
                    }
                } else {
                    auxTitleFile += " "+file[i].name;
                }
            }
        } else if (file.length > 0 && !multiFiles){
            setTitleFile("");
            setNameFile("");

            var size = parseFloat(file[0].size / (1024 * 1024)).toFixed(2);

            if(size > maxFileSize) {
                setErroUploadFile(msgErrorFileSize);
                setErro = true;
                setTitleFile("");
                onFileSelectSuccess(null);
                setDataFile(null);
                deleteFile();
            } else if (!extensionsAccepted(file[0].name,typeFile)) {
                setErroUploadFile(decode_utf8(dataProps?.erro_extension_no_compatible)+"["+typeFile.replaceAll(';',' - ')+"]");
                setErro = true;
                setTitleFile("");
                onFileSelectSuccess(null);
                setDataFile(null);
                deleteFile();
            } else {
                auxTitleFile += " "+file[0].name;
            }
        } else {
            setErro = true;
        }

        if(!setErro) {
            setTitleFile(auxTitleFile);
            onFileSelectSuccess(file);
            setDataFile(file);
            if(file.length > 1) {
                setNameFile(file.length+" archivos");
            } else {
                setNameFile(file[0].name);
            }
        }
    };

    React.useEffect(() => {
        const objFile = document.querySelector(`#${idInput}`)?.value;
        if(!objFile) {
            setDataFile(null);
        }
    },[document.querySelector(`#${idInput}`)?.value]);
    
    return (
        <>
            <div className="pb-4">
                {labelInput && <h4 className="mb-0">{labelInput} {mandatoryElement ? <b class="text-danger">*</b> : ''}</h4>}
                <div className="d-flex align-items-center">
                    <input type="file"  className="file-input__input"  name={idInput} id={idInput} onChange={handleFileInput}/>
                    <label className="file-input__label" for={idInput}>Elija el archivo</label>

                    {dataFile && 
                    <>
                        <p className="mb-0 name-file" title={titleFile}> {nameFile} </p>
                        <TrashFill className="text-danger icon" onClick={() => {
                            deleteFile();
                            setDataFile(null);
                        }} />
                    </>
                    }
                    
                </div>
                {hasError &&
                    <div>
                        <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
                    </div>
                    
                }
            </div>
        </>
    );
};

export default FileUploader;